import { Constants } from '@areapif/areapif-backend'
import type { InspectionLevel } from '@areapif/areapif-shared'

/**
 * Every inspection level, in the order the database enum declares them.
 *
 * Read straight off `Constants.public.Enums.inspection_level` rather than
 * written out here, so a level the enum gains cannot go missing from the filter
 * that offers them. The annotation is what ties the two vocabularies together:
 * were the generated enum and the shared `InspectionLevel` union to drift, this
 * line stops compiling instead of the filter quietly offering a level the rest
 * of the app cannot render.
 */
export const INSPECTION_LEVELS: readonly InspectionLevel[] = Constants.public.Enums.inspection_level
